import Vue from 'vue'
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import App from './App.vue'
import router from './router'
import store from './store'
import VueResource from 'vue-resource'
import axios from 'axios'
import i18n from './i18n'
import Notifications from 'vue-notification'
import VModal from 'vue-js-modal'
import Constants from "frontend_common/src/constants/globalConstants";
import VueLogger from 'vuejs-logger';
import { BootstrapVue } from 'bootstrap-vue'

import GlobalComponents from 'frontend_common/src/globalComponents'
import GlobalDirectives from 'frontend_common/src/globalDirectives'
import SideBar from 'frontend_common/src/components/UIComponents/SidebarPlugin'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'frontend_common/src/assets/sass/element_variables.scss'
import 'frontend_common/src/assets/sass/paper-dashboard.scss'

import sidebarLinks from "./sidebarLinks"
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'

// import * as Sentry from '@sentry/browser';
// import * as Integrations from '@sentry/integrations';

// Sentry.init({
//     dsn: 'https://8a9fc0695b264cce8daa07d324f97f20@sentry.io/2973950',
//     integrations: [new Integrations.Vue({Vue, attachProps: true, logErrors: true})],
// });

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(VueResource);
Vue.use(Notifications);
Vue.use(VModal, { dynamic: true, dynamicDefault: { draggable: true, resizable: true }, injectModalsContainer: true });
Vue.use(SideBar, {sidebarLinks: sidebarLinks});
Vue.use(GlobalDirectives);
Vue.use(GlobalComponents);

locale.use(lang);

const isProduction = process.env.NODE_ENV === 'production';
const options = {
  isEnabled: true,
  logLevel : isProduction ? 'error' : 'debug',
  stringifyArguments : true,
  showLogLevel : true,
  showMethodName : false,
  separator: '|',
  showConsoleColors: true
};
Vue.use(VueLogger, options);

const moment = require('moment')
require('moment/locale/si')

Vue.use(require('vue-moment'), {
  moment
});

const instance = axios.create({
  baseURL: "/pos_admin/api",
  timeout: 40000,
  withCredentials: true,
  headers: {'X-Requested-With': 'XMLHttpRequest'},
});
// Setting up Axios on Vue Instance, for use via this.$axios
Vue.prototype.$axios = instance;

// Add a request interceptor
instance.interceptors.request.use(function (config) {
  // if(config.url !== "/log" && config.url !== "/login") {
  //     let request = {"source": "Client", "level": "trace", "message": "Calling " + config.url + "Payload: " + JSON.stringify(config.data)};
  //     store.dispatch('serverLog', request);
  // }

  if (config.url !== "/auth") {
    const CSRF_TOKEN = document.cookie.match(new RegExp(`XSRF-TOKEN=([^;]+)`))[1];
    config.headers =  { "X-XSRF-TOKEN": CSRF_TOKEN, 'X-Requested-With': 'XMLHttpRequest' }
  }
  return config;
});

instance.interceptors.response.use(response => {
      Vue.$log.debug("Server returned: ", response);

      // if(response.config.url !== "/log") {
      //     let request = {"source": "Client", "level": "trace", "message": "Retrieved response from " + response.config.url + " Success: " + response.data.success};
      //     store.dispatch('serverLog', request);
      // }
      return Promise.resolve(response)

    },
    error => {
      if(typeof(error.response) !== 'undefined' && error.response !== null)
        Vue.$log.error("Server error: ", error.response.data);
      if(typeof(error.response) === 'undefined' || error.response === null) {
        error.message = i18n.t('error.system');
        return Promise.reject(error);
      } else if (error.response.status === Constants.HTTP_401) { // || error.response.status === 401
        error.message = i18n.t('error.session-expired');
        store.dispatch('performLogout');
        return Promise.reject(error)
      }  else if (error.response.status === Constants.HTTP_403) {
        if(error.config.url !== '/login') {
          error.message = i18n.t('error.auth-failed');
          store.dispatch('performLogout');
        } else {
          error.message = i18n.t('error.login-invalid');
        }
        return Promise.reject(error)
      } else {
        error.message = handleError(error);
        return Promise.reject(error)
      }
    });


function handleError(response) {
  if(typeof (response) === 'undefined') {
    Vue.$log.error(i18n.t('error.system'));
    return i18n.t('error.system');
  } else if (typeof (response.data) !== 'undefined' && typeof (response.data.message) !== 'undefined' && response.data.message != null) {
    Vue.$log.error(response.data.message);
    return response.data.message;
  } else if (typeof (response.message) !== 'undefined' && response.message != null) {
    Vue.$log.error(response.message);
    return response.message;
  } else {
    Vue.$log.error(i18n.t('error.system'));
    return i18n.t('error.system');
  }
}

Vue.config.errorHandler = (err, vm, info) => {
  Vue.$log.error('[Global Error Handler]: Error in ' + info + 'Error: ' + err);
  let request = {"source": "Client", "level": "error", "message": info + "\nError: " + err};
  store.dispatch('serverLog', request);
};

Vue.config.warnHandler = function (err, vm, info) {
  Vue.$log.error('[Global Warn Handler]: Error in ' + info + 'Error: ' + err);
  let request = {"source": "Client", "level": "error", "message": info + "\nError: " + err};
  store.dispatch('serverLog', request);
};

Vue.mixin({
  methods: {
    logInfo: function (message) {
      Vue.$log.info(message);
      let request = {"source": "Client", "level": "info", "message": message};
      store.dispatch('serverLog', request);
    },
    logError: function (message) {
      Vue.$log.error(message);
      let request = {"source": "Client", "level": "error", "message": message};
      store.dispatch('serverLog', request);
    },
    logDebug: function (message) {
      Vue.$log.debug(message);
      let request = {"source": "Client", "level": "debug", "message": message};
      store.dispatch('serverLog', request);
    },
    logTrace: function (message) {
      Vue.$log.debug(message);
      let request = {"source": "Client", "level": "trace", "message": message};
      store.dispatch('serverLog', request);
    }
  }
});

new Vue({
  render: h => h(App),
  store,
  router,
  i18n,
  components: { App }
}).$mount('#app');
